export default "__VITE_ASSET__DjPJX6rU__"